var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-base",
    { staticClass: "brick-octagon" },
    [
      _vm._t("content-top"),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "svg-root",
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            width: "97",
            height: "97",
            viewBox: "0 0 97 97"
          }
        },
        [
          _c("defs", [
            _c(
              "filter",
              { attrs: { id: "shadow" } },
              [
                _c("feDropShadow", {
                  attrs: {
                    dx: "4.55",
                    dy: "4.55",
                    stdDeviation: "5",
                    "flood-color": "rgba(0,0,0, 0.74)"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "filter",
              {
                attrs: {
                  id: "Polygon_1",
                  x: "0",
                  y: "0",
                  width: "97",
                  height: "97",
                  filterUnits: "userSpaceOnUse"
                }
              },
              [
                _c("feDropShadow", {
                  attrs: {
                    dx: "0",
                    dy: "0",
                    stdDeviation: "0.5",
                    "flood-color": "cyan"
                  }
                }),
                _vm._v(" "),
                _c("feOffset", { attrs: { input: "SourceAlpha" } }),
                _vm._v(" "),
                _c("feGaussianBlur", {
                  attrs: { stdDeviation: "1", result: "blur" }
                }),
                _vm._v(" "),
                _c("feComposite", { attrs: { in: "SourceGraphic" } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "filter",
              {
                attrs: {
                  id: "map-signs-solid",
                  x: "21.5",
                  y: "24.5",
                  width: "54",
                  height: "54",
                  filterUnits: "userSpaceOnUse"
                }
              },
              [
                _c("feOffset", { attrs: { input: "SourceAlpha" } }),
                _vm._v(" "),
                _c("feGaussianBlur", {
                  attrs: { stdDeviation: "0.5", result: "blur-2" }
                }),
                _vm._v(" "),
                _c("feFlood", { attrs: { "flood-opacity": "0.161" } }),
                _vm._v(" "),
                _c("feComposite", { attrs: { operator: "in", in2: "blur-2" } }),
                _vm._v(" "),
                _c("feComposite", { attrs: { in: "SourceGraphic" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                id: "octagon_divider",
                "data-name": "octagon divider",
                transform: "translate(3 3)"
              }
            },
            [
              _c(
                "g",
                {
                  staticClass: "cls-7",
                  attrs: { transform: "matrix(1, 0, 0, 1, -3, -3)" }
                },
                [
                  _c(
                    "g",
                    {
                      staticClass: "cls-1",
                      attrs: {
                        id: "Polygon_1-2",
                        "data-name": "Polygon 1",
                        transform: "translate(3 3)"
                      }
                    },
                    [
                      _c("path", {
                        staticClass: "cls-3 background",
                        attrs: {
                          d:
                            "M 61.86142349243164 90.5 L 29.13856506347656 90.5 C 27.66945838928223 90.5 26.28828239440918 89.92789459228516 25.24946975708008 88.88908386230469 L 2.110917568206787 65.75051879882813 C 1.072105884552002 64.71170806884766 0.5 63.33052825927734 0.5 61.86142349243164 L 0.5000117421150208 29.13855361938477 C 0.5000117421150208 27.66945838928223 1.072117686271667 26.28828239440918 2.110929489135742 25.24946975708008 L 25.2494945526123 2.110917568206787 C 26.28830528259277 1.072105884552002 27.66948318481445 0.5 29.13857650756836 0.5 L 61.86142349243164 0.5000117421150208 C 63.33052825927734 0.5000117421150208 64.71169281005859 1.072105884552002 65.75051879882813 2.110917568206787 L 88.88909149169922 25.24948310852051 C 89.92790222167969 26.28830528259277 90.5 27.66948318481445 90.49998474121094 29.13857650756836 L 90.49998474121094 61.86143493652344 C 90.49998474121094 63.33053970336914 89.92789459228516 64.71170806884766 88.88908386230469 65.75052642822266 L 65.75051879882813 88.88908386230469 C 64.71170806884766 89.92789459228516 63.33052825927734 90.5 61.86142349243164 90.5 Z"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "cls-4",
                        attrs: {
                          d:
                            "M 29.13857650756836 1 C 27.80302429199219 1 26.54740905761719 1.520088195800781 25.60305023193359 2.4644775390625 L 2.4644775390625 25.60303497314453 C 1.520088195800781 26.54740905761719 1 27.80301284790039 1 29.1385612487793 L 1 61.86142730712891 C 1 63.19697570800781 1.520088195800781 64.45259094238281 2.464462280273438 65.39694976806641 L 25.60303497314453 88.53553771972656 C 26.54740142822266 89.47991180419922 27.80301284790039 90 29.1385612487793 90 L 61.86142730712891 90 C 63.19697570800781 90 64.45259094238281 89.47991180419922 65.39694976806641 88.5355224609375 L 88.5355224609375 65.39696502685547 C 89.47989654541016 64.45259857177734 89.99998474121094 63.19698715209961 89.99998474121094 61.86143493652344 L 89.99998474121094 29.1385612487793 C 90 27.80302429199219 89.47991180419922 26.54740905761719 88.5355224609375 25.60303497314453 L 65.39694976806641 2.4644775390625 C 64.45257568359375 1.520088195800781 63.19697570800781 1 61.86142730712891 1 L 29.13857650756836 1 M 29.13857650756836 0 L 61.86142730712891 0 C 63.45272445678711 0 64.97885131835938 0.6321487426757813 66.10406494140625 1.757362365722656 L 89.24263763427734 24.89592742919922 C 90.36785888671875 26.02114868164063 91 27.54727554321289 90.99998474121094 29.13857650756836 L 90.99998474121094 61.86143493652344 C 90.99998474121094 63.45273590087891 90.36785125732422 64.97886657714844 89.24263763427734 66.10407257080078 L 66.10406494140625 89.24263763427734 C 64.97885131835938 90.36785888671875 63.45272445678711 91 61.86142730712891 91 L 29.1385612487793 91 C 27.54726409912109 91 26.02114105224609 90.36785888671875 24.89592742919922 89.24263763427734 L 1.757347106933594 66.10406494140625 C 0.63214111328125 64.97885131835938 0 63.45272445678711 0 61.86142730712891 L 0 29.1385612487793 C 0 27.54726409912109 0.6321487426757813 26.02114105224609 1.757362365722656 24.89592742919922 L 24.89593505859375 1.757362365722656 C 26.02114868164063 0.63214111328125 27.54727554321289 0 29.13857650756836 0 Z"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                {
                  staticClass: "cls-6",
                  attrs: { transform: "matrix(1, 0, 0, 1, -3, -3)" }
                },
                [_vm._t("icon")],
                2
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm._t("content-bottom")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }